export function findCursus(formations) {
  return formations.map(el => ({
    field: el.field,
    fullName: el.fullName,
    label: el.cursus,
    value: el.cursus
  }))
}

// export function constructParams(formationsChoisies, formations) {
//   const formationsParams = formations.filter(el => formationsChoisies.includes(el.formation)).map(el => '&programme[]=' + el.param)
//   return formationsParams.join('')
// }
